/* eslint-disable max-len */
import XnoQuestion from 'images/coin-pages/questions/xno.svg'

import { ECoinPageParagraphTypes, ICoinPageData } from '../types'

export const xnoPage: ICoinPageData = {
  title: 'coin_709',
  description: 'coin_710',
  // description:
  //   'Lend NANO (XNO) cryptocurrency with collateral on CoinRabbit, an instant crypto lending service without credit checks, monthly payments, and maximum loan sizes.',
  questionsBlock: {
    image: XnoQuestion,
    questions: [
      {
        title: 'coin_711',
        answer: 'coin_712',
      },
      {
        title: 'coin_713',
        answer: 'coin_714',
      },
      {
        title: 'coin_715',
        answer: 'coin_716',
      },
      {
        title: 'coin_717',
        answer: 'coin_718',
      },
      {
        title: 'coin_719',
        answer: 'coin_720',
      },
      {
        title: 'coin_721',
        answer: 'coin_722',
      },
    ],
  },
  whatIs: {
    text: ['coin_725'],
    paragraphs: [
      {
        title: 'coin_723',
        text: ['coin_726'],
      },
      {
        title: 'coin_724',
        text: ['coin_727', 'coin_728', 'coin_729', 'coin_730', 'coin_731'],
        type: ECoinPageParagraphTypes.ul,
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/enhance-nano-holdings/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/integration_10CR_NA2.png',
        imageAlt: 'NANO (XNO) crypto review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'NANO (XNO) crypto review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'NANO (XNO) crypto review 7',
      },
    ],
  },
}
